<template>
<section class="footer pb5">
    <div class="container">
        <div class="row">
            <!-- Column 1 -->
            <div class="col-md-3 col-sm-6 mb-3">
                <h5>About INFOCRATS</h5>
                <p>
                    Established in 1996, INFOCRATS Web
                    Solutions PVT LTD, proved to be a start-
                    up that revolutionized its client’s digital
                    journey.
                </p>
            </div>

            <!-- Column 2 -->
            <div class="col-md-3 col-sm-6 mb-3">
                <h5>Quick Links</h5>
                <ul class="list-unstyled">
                    <li><router-link to="/about-us" >About Us</router-link></li>
                    <li><a href="/careers">Careers</a></li>
                    <li><router-link to="/blogs" >Blog</router-link></li>
                    <li><router-link to="/privacy-policy" >Privacy Policy</router-link></li>
                    <li><router-link to="/child-safety-policy" >Child Safety Policy</router-link></li>
                    <li><router-link to="/disclaimers" >Disclaimer</router-link></li>
                    <li><router-link to="/contact-us" >Contact</router-link></li>
                </ul>
            </div>

            <!-- Column 3 -->
            <div class="col-md-3 col-sm-6 mb-3">
                <h5>Connect With Us</h5>
                <table>
                    <tr>
                        <td>
                            <div class="box"><i class="fa fa-phone"></i></div>
                        </td>
                        <td class="pb5"><b>PHONE NUMBER</b><br />
                           <a href="tel:07314965651"> 0731-4965651</a></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="box"><i class="fa fa-envelope"></i></div>
                        </td>
                        <td class="pb5"><b>EMAIL ADDRESS</b><br />
                           <a href="mailto:info@infocratsweb.com"> info@infocratsweb.com</a></td>
                    </tr>
                    <tr>
                        <td>
                            <div class="box"><i class="fa fa-map-marker"></i></div>
                        </td>
                        <td><b>OFFICE LOCATION</b><br />
                            
                            
                            <a href="https://www.google.com/maps/search/?api=1&query=21/1+Race+Course+Road,+Indore,+M.P.+452003" 
   target="_blank">
   21/1 Race Course Road,<br /> Indore (M.P.) - 452003
</a>
                            
                            </td>
                    </tr>
                </table>

            </div>

            <!-- Column 4 -->
            <div class="col-md-3 col-sm-6 mb-3">
                <h5>Follow Us</h5>
                <ul class="social-link">
                    <li class="list-inline-item">
                        <a href="https://www.facebook.com/InfocratsWebSolutions" target="_blank"><i class="fa fa-facebook"></i></a>
                    </li>
                    <li class="list-inline-item">
                        <a href="https://twitter.com/infocratsweb" target="_blank"><i class="fa fa-twitter"></i></a>
                    </li>
                    <li class="list-inline-item">
                        <a href="https://instagram.com/infocratswebsolutions?utm_medium=copy_link" target="_blank"><i class="fa fa-instagram"></i></a>
                    </li>
                    <li class="list-inline-item">
                        <a href="https://www.linkedin.com/company/infocrat-web-solutions-pvt-ltd/" target="_blank"><i class="fa fa-linkedin"></i></a>
                    </li>
                    <li class="list-inline-item">
                        <a href="https://www.youtube.com/channel/UCXK57Fws91a2rQpfeUkFMzw/featured?view_as=subscriber" target="_blank"><i class="fa fa-youtube"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
<section class="copyright p2">
    Copyright 2025 — Infocrats Web Solution. © All Rights Reserved.
</section>
</template>

<script>
export default {
    name: 'FooterComponent',
    props: {
        msg: String
    }
}

</script>